import fs from 'fs'
import path from 'path'

import { TOKEN_DIR, TOKEN_FILE } from '../constants'

// `.flowrunner/token` — the untracked half. Writing one always makes sure `.gitignore` covers it: a deploy
// token committed to a repository is the kind of mistake that is discovered by someone else.

export function tokenPath(projectRoot: string = process.cwd()): string {
  return path.resolve(projectRoot, TOKEN_FILE)
}

export function readToken(projectRoot: string = process.cwd()): string | null {
  const fullPath = tokenPath(projectRoot)

  if (!fs.existsSync(fullPath)) {
    return null
  }

  return fs.readFileSync(fullPath, 'utf-8').trim()
}

export function writeToken(token: string, projectRoot: string = process.cwd()): void {
  const dir = path.resolve(projectRoot, TOKEN_DIR)

  if (!fs.existsSync(dir)) {
    fs.mkdirSync(dir, { recursive: true })
  }

  fs.writeFileSync(tokenPath(projectRoot), token, 'utf-8')
}

export function deleteToken(projectRoot: string = process.cwd()): void {
  const fullPath = tokenPath(projectRoot)

  if (fs.existsSync(fullPath)) {
    fs.unlinkSync(fullPath)
  }
}

export function ensureGitignore(projectRoot: string = process.cwd()): void {
  const gitignorePath = path.resolve(projectRoot, '.gitignore')

  if (!fs.existsSync(gitignorePath)) {
    fs.writeFileSync(gitignorePath, `${ TOKEN_DIR }/\n`, 'utf-8')

    return
  }

  const content = fs.readFileSync(gitignorePath, 'utf-8')

  if (!content.includes(TOKEN_DIR)) {
    fs.appendFileSync(gitignorePath, `\n${ TOKEN_DIR }/\n`)
  }
}
